module.exports = __webpack_public_path__ + "static/media/af-heart-filled.cb708222.svg";